import { render, staticRenderFns } from "./OtherUserGroupEdit.vue?vue&type=template&id=5ac1f072&scoped=true&lang=pug"
import script from "./OtherUserGroupEdit.vue?vue&type=script&lang=ts"
export * from "./OtherUserGroupEdit.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserGroupEdit.vue?vue&type=style&index=0&id=5ac1f072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac1f072",
  null
  
)

export default component.exports